import o,{css as e}from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{StyledButtonBase as r}from"./ButtonBase.styled.js";import{defaultTheme as l}from"../../../theme/index.js";const a=l.theme["colorVariables"],t=o(r)`
  height: 36px;
  padding: 0 20px;
  color: ${a.textDark};
  background-color: ${e=>e.alternative?a.bgPrimary:a.bgPaleYellow};
  border: 1px solid ${a.borderYellow};

  &:hover {
    background-color: ${e=>e.alternative?a.bgPaleYellow:a.bgYellow};
  }

  &:before {
    display: none;
    background-color: ${a.bgPaleYellow};
  }

  &[disabled] {
    color: ${a.textNote};
    border: 1px solid ${a.borderPrimary};
    background: ${a.bgPrimary};
    cursor: default;
    pointer-events: none;
  }

  &[disabled]:hover {
    background: ${a.bgPrimary};
  }

  &:not([disabled]):active {
    box-shadow: 0 0 0 4px rgba(255, 202, 0, 0.5);

    ${o=>o.alternative&&e`
        border-color: ${a.bgPaleYellow};
      `}
  }
`;export{t as StyledButtonCard};
